import React from 'react';
import { connect } from "react-redux";

import landnotification_logo from '../../img/trimin_landnotification_verysmall.png';

const mapStateToProps = state => {
	return {
		countyName: state.countyConfigCommonReducer.countyName,
		appTitle: state.countyConfigCommonReducer.appTitle
	};
}

class LoginTop extends React.Component {

	handleTriminClick = (event) => {
		event.preventDefault();
		window.open("https://www.trimingov.com/");
	};

	render() {
		return (
			<header className="container-fluid" style={{borderBottom: '3px solid black'}} >
				<table>
					<tbody>
						<tr>
							<td valign="bottom">
								<table align="center" width="100%">
									<tbody>
										<tr>
											<td>
												<span style={{ color: '#003E7F', fontSize: 36, fontVariant: 'small-caps', fontWeight: 'bold' }}>{this.props.countyName} {this.props.appTitle}</span>
											</td>
										</tr>
										<tr>
											<td>
												<span style={{ fontSize: 20, fontWeight: 500, marginTop: 50 }}>&nbsp;powered by&nbsp;</span>
												<img border="0" src={landnotification_logo} alt="Trimin LandNotification" style={{ paddingBottom: 15, cursor: "pointer" }} onClick={ this.handleTriminClick} />
											</td>
										</tr>
									</tbody>
								</table>
							</td>
							{/* <td valign="bottom" width="1%">
								{rightHandSide}
							</td> */}
						</tr>
					</tbody>
				</table>
			</header>
		)
	}
}

export default connect(mapStateToProps)(LoginTop);